import styles from "./spacer.module.css";

export function Spacer() {
  return <div className={styles.root} />;
}
